var _defs, _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBridgeCentreLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 547.57 264.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        font-family: Montserrat-Black, Montserrat;\n        font-size: 45.5px;\n        font-weight: 800;\n      }\n\n      .st0, .st1, .st2 {\n        fill: #20386d;\n      }\n\n      .st3 {\n        fill: none;\n        stroke: #20386d;\n        stroke-miterlimit: 10;\n        stroke-width: 7px;\n      }\n\n      .st1 {\n        font-family: Montserrat-SemiBold, Montserrat;\n        font-size: 20px;\n        font-weight: 600;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M160.83,163.66h20.9c10.94,0,17.4-8.87,17.4-19.8v-40.36c0-2.28-1.84-4.11-4.11-4.11h-45.46v-29.78c0-10.94-8.87-19.8-19.8-19.8h-40.36c-1.42,0-2.67.72-3.4,1.81-.44.66-.7,1.45-.7,2.3v45.47h-29.77c-10.89,0-19.79,8.91-19.79,19.79v44.47h49.56v25.29c0,13.39,10.89,24.27,24.27,24.27h35.89c2.27,0,4.11-1.83,4.11-4.11v-40.88"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M127.09,138.92c-4.8,5.98-7.23,13.09-7.43,20.2-.02.6-.5,1.09-1.1,1.09l-6.82.02c-.62,0-1.12-.5-1.11-1.12.2-9.09,3.28-18.2,9.41-25.84,6.13-7.64,14.35-12.62,23.19-14.78.6-.15,1.2.24,1.33.84l1.45,6.66c.13.59-.24,1.16-.82,1.31-6.9,1.73-13.31,5.64-18.11,11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M139.32,148.74c-2.47,3.08-3.77,6.73-3.96,10.4-.03.57-.52,1.01-1.1,1.02l-6.48.02c-.64,0-1.13-.53-1.11-1.17.22-5.53,2.14-11.05,5.88-15.7,3.73-4.65,8.7-7.72,14.05-9.13.61-.16,1.24.21,1.38.83l1.38,6.33c.12.56-.2,1.14-.76,1.29-3.54.98-6.82,3.04-9.29,6.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M151.02,151.05l1.98,9.06-9.28.03c-.66,0-1.18-.57-1.1-1.23.22-1.89.95-3.75,2.23-5.34,1.28-1.6,2.93-2.71,4.73-3.33.62-.21,1.3.17,1.44.81Z"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st0",
    transform: "translate(208.81 130.45)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "BRIDGE"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(209.32 156.93)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CENTRE FOR DIGITAL HEALTH"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridgeCentreLogo);
export default __webpack_public_path__ + "static/media/BRIDGE_Centre_Logo.aea45219b94105e1de74edf7135f62e5.svg";
export { ForwardRef as ReactComponent };